import { useMemo } from "react";

import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { TextAreaWithCount } from "../../../../components/Inputs/TextAreaWithCount";
import { useAuth } from "../../../../hooks/auth/useAuth";
import { Role } from "../../../../models";
import { OutsideEnrollmentAreaStatus } from "../../../../models/Request";
import { RequestRemark } from "../../../../models/Request/Request";
import { isStatusSuggestedEnrollment } from "../../../../utils/status.util";

interface RequestRemarkTextAreaProps {
  requestRemark: RequestRemark;
  isEditing: boolean;
  outsideEnrollmentAreaStatus: OutsideEnrollmentAreaStatus | null;
  onChange: (remark: RequestRemark) => void;
}

export const RequestRemarkTextArea = ({
  requestRemark,
  isEditing,
  outsideEnrollmentAreaStatus,
  onChange,
}: RequestRemarkTextAreaProps) => {
  const { t } = useTranslation();
  const auth = useAuth();

  const isEditable = useMemo(() => {
    const isStatusEditable = isStatusSuggestedEnrollment(
      outsideEnrollmentAreaStatus
    );

    const hasAllowedRole = auth.hasRoleAccess({
      whitelist: [
        Role.InstitutionPrincipal,
        Role.InstitutionAdministrator,
        Role.InstitutionCommittee,
      ],
    });

    return isEditing && hasAllowedRole && isStatusEditable;
  }, [isEditing, auth, outsideEnrollmentAreaStatus]);

  const handleNoteChange = (value: string) => {
    onChange({
      ...requestRemark,
      remark: value,
    });
  };

  return (
    <Row>
      <Col md={12}>
        <TextAreaWithCount
          ariaLabel={t("suggestedOutsideEnrollmentArea.note")}
          label={t("suggestedOutsideEnrollmentArea.note")}
          name="note"
          value={requestRemark?.remark ?? ""}
          onChange={handleNoteChange}
          maxLength={1000}
          disabled={!isEditable}
          rows={4}
        />
      </Col>
    </Row>
  );
};
